export default {
  /* ************************基础配置****************************** */

  //用户店铺权限下拉列表
  userStoreList: {
    url: '/ec-pc-api/clearStock/manage/userStoreList',
    type: 'get'
  },
  //基础配置-提报店铺-编辑  
  storeReportUpdate: {
    url: '/ec-pc-api/clearStock/manage/store/report/update',
    type: 'post'
  },
  //基础配置-店铺权限-删除 
  storeUserDel: {
    url: '/ec-pc-api/clearStock/manage/storeUser/del',
    type: 'get'
  },
  //基础配置-店铺权限-新增-编辑
  saveOrUpdate: {
    url: '/ec-pc-api/clearStock/manage/storeUser/saveOrUpdate',
    type: 'post'
  },
  //退市-预退市跟进信息动态分页
  exitMarketPackSearch: {
    url: '/ec-pc-api/clearStock/manage/exitMarket/pack/search',
    type: 'post'
  },
  //退市-预退市跟进信息-删除
  exitMarketPackDel: {
    url: '/ec-pc-api/clearStock/manage/exitMarket/pack/del',
    type: 'get'
  },
  //退市-预退市跟进信息-导出
  exitMarketPackExport: {
    url: '/ec-pc-api/clearStock/manage/exitMarket/pack/export',
    type: 'post'
  },
  //清仓店铺-申请调整
  goodsAdjustApply: {
    url: '/ec-pc-api/clearStock/manage/goods/adjust/apply',
    type: 'post'
  },
  //清仓商品-下架
  goodsShelfRemove: {
    url: '/ec-pc-api/clearStock/manage/goods/shelfRemove',
    type: 'get'
  },
  //清仓商品-删除
  goodsDel: {
    url: '/ec-pc-api/clearStock/manage/goods/del',
    type: 'post'
  },
  //清仓商品-新增-更新
  goodsSaveOrUpdate: {
    url: '/ec-pc-api/clearStock/manage/goods/saveOrUpdate',
    type: 'post'
  },
  //清仓店铺-消息通知-是否包含新消息
  messageStatus: {
    url: '/ec-pc-api/clearStock/manage/store/message/status',
    type: 'get'
  },
  //全平台-修改日志
  modifyLogSearch: {
    url: '/ec-pc-api/clearStock/manage/plat/modifyLog/search',
    type: 'post'
  },
  //清仓店铺-消息通知-已处理消息
  processedMessageSearch: {
    url: '/ec-pc-api/clearStock/manage/store/processedMessage/search',
    type: 'post'
  },
  //清仓店铺-处理申请
  adjustProcess: {
    url: '/ec-pc-api/clearStock/manage/goods/adjust/process',
    type: 'post'
  },
  //全平台-修改日志-一键已读
  modifyLogOneKeyRead: {
    url: '/ec-pc-api/clearStock/manage/plat/modifyLog/oneKeyRead',
    type: 'get'
  },
  //全平台-各店铺清仓完成进度动态分页
  completeInfoSearch: {
    url: '/ec-pc-api/clearStock/manage/plat/goods/completeInfo/search',
    type: 'post'
  },
  //全平台-各店铺清仓完成进度动态分页[导出]
  completeInfoExport: {
    url: '/ec-pc-api/clearStock/manage/plat/goods/completeInfo/export',
    type: 'post'
  },
  //清仓商品-查询详情
  goodsRowSreach: {
    url: '/ec-pc-api/clearStock/manage/goods',
    type: 'post'
  },
  //店铺清仓情况弹窗
  storeGoodsSaleInfo: {
    url: '/ec-pc-api/clearStock/manage/store/goods/saleInfo',
    type: 'post'
  },
  //清仓商品调整记录分页
  adjustLogSearch: {
    url: '/ec-pc-api/clearStock/manage/goods/adjustLog/search',
    type: 'post'
  },
  //全网清仓完成进度动态分页
  wholeNetworkSearch: {
    url: '/ec-pc-api/clearStock/manage/all/goods/completeInfo/search',
    type: 'post'
  },
  //全网清仓完成进度动态分页[导出]
  wholeNetworkExport: {
    url: '/ec-pc-api/clearStock/manage/all/goods/completeInfo/export',
    type: 'post'
  },
  //全网清仓情况弹窗
  allGoodsSaleInfo: {
    url: '/ec-pc-api/clearStock/manage/all/goods/saleInfo',
    type: 'post'
  },
  //导入清仓管理-店铺商品信息
  goodsInfoImport: {
    url: '/ec-pc-api/customize/import/clearStock/store/goodsInfo',
    type: 'post'
  },
  //全网-各店铺完成情况列表
  completeInfoList: {
    url: '/ec-pc-api/clearStock/manage/store/goods/completeInfoList',
    type: 'post'
  },
  //获取清仓导入模板
  clearStockTemplate: {
    url: '/ec-pc-api/clearStock/manage/import/template/download',
    type: 'post'
  },
  //清仓商品-批量下架
  shelfRemoveBatch: {
    url: '/ec-pc-api/clearStock/manage/goods/shelfRemove/batch',
    type: 'post'
  },
}